module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "to-form-add",
    style: (_vm.navPosition),
    attrs: {
      "id": "moveNav"
    },
    on: {
      "mousedown": _vm.navDown,
      "touchstart": _vm.navDown,
      "mousemove": _vm.navMove,
      "touchmove": _vm.navMove,
      "mouseup": _vm.navEnd,
      "touchend": _vm.navEnd
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/activity/bg-kefe-icon.png"),
      "alt": "",
      "srcset": ""
    },
    on: {
      "click": _vm.onShow
    }
  })]), _vm._v(" "), (_vm.navShow) ? _c('div', {
    staticClass: "xuanfu info-nr-phone",
    style: (_vm.position),
    attrs: {
      "id": "moveDiv"
    },
    on: {
      "mousedown": _vm.down,
      "touchstart": _vm.down,
      "mousemove": _vm.move,
      "touchmove": _vm.move,
      "mouseup": _vm.end,
      "touchend": _vm.end
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-304370f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavFloatService.vue
// module id = 2290
// module chunks = 0